import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import { getUserType } from "../../utils/authutils";
import AdminDashboardSkeleton from "../../pages/AdminDashboardSkeleton";
import Loader from "./Loader";

const AdminDashboard = lazy(() => import("../../pages/Dashboard"));
const CustomerDashboard = lazy(() => import("../../pages/CustomerFlow/CustomerDashboard"));
const ClientDashboard = lazy(() => import("../../pages/Clients/Dashboard"));
const ContractorDashboard = lazy(() => import("../../pages/Contractor"));
const ProjectManagerDashboard = lazy(() => import("../../pages/ProjectManager/Dashboard"));
const FieldWorkerDashboard = lazy(() => import("../../pages/FieldWorker/Dasboard"));

const RoleBasedDashboard = () => {
  const userType = getUserType();

  switch (userType) {
    case "admin":
      return (
        <Suspense
          fallback={
            <div>
              <AdminDashboardSkeleton />
            </div>
          }
        >
          <AdminDashboard />
        </Suspense>
      );

    case "customer":
      return (
        <Suspense fallback={<Loader />}>
          <CustomerDashboard />
        </Suspense>
      );

    case "client":
    case "client_member":
      return (
        <Suspense fallback={<Loader />}>
          <ClientDashboard />
        </Suspense>
      );

    case "contractor_owner":
    case "contractor_admin":
      return (
        <Suspense fallback={<Loader />}>
          <ContractorDashboard />
        </Suspense>
      );

    case "contractor_manager":
      return (
        <Suspense fallback={<Loader />}>
          <ProjectManagerDashboard />
        </Suspense>
      );

    case "contractor_worker":
      return (
        <Suspense fallback={<Loader />}>
          <FieldWorkerDashboard />
        </Suspense>
      );

    default:
      return <Navigate to="/login" />;
  }
};

export default RoleBasedDashboard;
